import { render, staticRenderFns } from "./CreateFaculty.vue?vue&type=template&id=3d4ecd9c&scoped=true&lang=true&"
import script from "./CreateFaculty.vue?vue&type=script&lang=js&"
export * from "./CreateFaculty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4ecd9c",
  null
  
)

export default component.exports